// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_4yl","cls2":"LoggedOutDiscoveryPage-cls2_-mV LoggedOutDiscoveryPage-cls1_4yl"};